export const authHeader = async () => {
  const user = await JSON.parse(window.localStorage.getItem('user'));
  if (user && user.accessToken) {
    return { 'x-access-token': user.accessToken, "Content-type": "application/json" };       // for Node.js Express back-end
  } else {
    return {};
  }
}